import Vue from "vue";
import Router from "vue-router";
import VueAnalytics from "vue-analytics";

//import App from "./App.vue";

//import { api } from "@/services/api.js";

import Home from "./pages/Home.vue";
import Home2 from "./pages/Home2.vue";
import Home3 from "./pages/Home3.vue";
import HomeAoVivo from "./pages/HomeAoVivo.vue";
import HomeProgramacao from "./pages/HomeProgramacao.vue";
import Sofascore from "./components/Sofascore.vue";
import Sofascore2 from "./components/Sofascore2.vue";
import Login from "./pages/Login.vue";
import Cadastro from "./pages/Cadastro.vue";
import LoginRecuperarSenhaEmail from "./pages/LoginRecuperarSenhaEmail.vue";

import Administracao from "./pages/Administracao.vue";
//import EditPlano from "./edits/EditPlano.vue";

import ListUsuarios from "./lists/ListUsuarios.vue";
import EditUsuario from "./edits/EditUsuario.vue";

import Eventos from "./pages/Eventos.vue";

import ViewEvento from "./pages/ViewEvento.vue";
import ViewEvento2 from "./pages/ViewEvento2.vue";
import TransmitEvento from "./pages/TransmitEvento.vue";
import LiveTransmitEvento from "./pages/LiveTransmitEvento.vue";

import SessaoView from "./pages/SessaoView.vue";

import Pay from "./pages/Pay.vue";
import AdminConfig from "./pages/AdminConfig.vue";

Vue.use(Router);

var arrRotas;
var site = process.env.VUE_APP_SITE;

if (process.env.VUE_APP_SITE == "Weddbets" || process.env.VUE_APP_SITE == "Bll") {
	var siteTemplate = localStorage.getItem("template");

	if (siteTemplate == "Weddbets" || siteTemplate == "Bll") {
		//* Verifica se foi definido um template
		if (siteTemplate !== null && siteTemplate !== "") {
			site = siteTemplate;
		}
	}
}

Vue.prototype.$site = site;
Vue.prototype.$sitePrincipal = process.env.VUE_APP_SITE;
Vue.prototype.$siteAdmin = process.env.VUE_APP_ADMIN && process.env.VUE_APP_ADMIN == "true" ? true : false;

/*

const verificaLogin = async (to, from, next) => {
  var indieKeySorteio = localStorage.getItem("ckd");

  if (indieKeySorteio !== null) {
    //* Carrega os dados
    const apiRequest = await api.get("/sessao/" + encodeURIComponent(indieKeySorteio));

    //* Atualiza o cache local
    if (apiRequest.data.itens.length > 0) {
      localStorage.setItem("ckdCch", JSON.stringify(apiRequest.data.itens[0]));

      var usuario = apiRequest.data.itens[0].usuario;

      if (usuario.tipoUsuario == "Administrador" && ["home", "programacao", "administracao", "usuarios", "eventos", "sessoes", "view", "transmit", "meus-dados", "sofascore"].includes(to.name)) {
        next();
      } else if (usuario.tipoUsuario == "Administrador Site" && ["home", "programacao", "administracao", "usuarios", "sessoes", "view", "meus-dados", "sofascore"].includes(to.name)) {
        next();
      } else if (usuario.tipoUsuario == "Apresentador" && ["home", "programacao", "eventos", "sessoes", "view", "transmit", "meus-dados", "sofascore"].includes(to.name)) {
        next();
      } else if (
        (usuario.tipoUsuario == "Assinante" || usuario.tipoUsuario == "Teste" || usuario.tipoUsuario == "Degustação" || usuario.tipoUsuario == "Sem acesso") &&
        ["home", "programacao", "view", "meus-dados", "sofascore"].includes(to.name)
      ) {
        next();
      } else {
        localStorage.removeItem("ckd");
        localStorage.removeItem("ckdCch");

        if (from.name !== "login") {
          next("/login");
          return;
        }
      }
    } else {
      localStorage.removeItem("ckd");
      localStorage.removeItem("ckdCch");

      if (from.name !== "login") {
        next("/login");
        return;
      }
    }
  } else {
    if (from.name !== "login") {
      next("/login");
      return;
    }
  }
};

*/

if (site == "Weddbets") {
	arrRotas = [
		{
			name: "home",
			path: "/",
			component: Home
		},
		{
			name: "favorito",
			path: "/fav",
			component: Home,
			props: {
				propFavorito: true
			}
		},
		{
			name: "sofascore",
			path: "/sofascore/:idEvento",
			component: Sofascore
		},
		{ name: "login", path: "/login", component: Login },
		{ name: "cadastro", path: "/i/:idUsuario", component: Cadastro },
		{
			name: "usuarios",
			path: "/usuarios",
			component: ListUsuarios
		},
		{
			name: "administracao",
			path: "/admin",
			component: Administracao
		},
		{
			name: "eventos",
			path: "/eventos",
			component: Eventos,
			props: {}
		},
		{
			name: "sessoes",
			path: "/sessoes",
			component: SessaoView
		},
		{
			name: "view",
			path: "/view/:id",
			component: ViewEvento
		},
		{
			name: "pay",
			path: "/pay",
			component: Pay
		},
		{
			name: "transmit",
			path: "/transmit/:id",
			component: TransmitEvento,
			props: {
				propView: ""
			}
		},
		{
			name: "meus-dados",
			path: "/meus-dados",
			component: EditUsuario,
			props: {
				propMeusDados: true,
				propView: "",
				hideHeader: false,
				propColunas: ["col-md-6", "offset-md-3"]
			}
		}
	];

	if (Vue.prototype.$siteAdmin == true) {

		arrRotas = arrRotas.concat([
			{
				name: "adminConfig",
				path: "/admin/config",
				component: AdminConfig
			},
		]);
	}

}

if (site == "Bll") {
	arrRotas = [
		{
			name: "home",
			path: "/",
			component: Home2
		},
		{
			name: "favorito",
			path: "/fav",
			component: Home2,
			props: {
				propFavorito: true
			}
		},
		{ name: "cadastro", path: "/i/:idUsuario", component: Cadastro },
		{
			name: "sofascore",
			path: "/sofascore/:idEvento",
			component: Sofascore
		},
		{ name: "login", path: "/login", component: Login },
		{
			name: "pay",
			path: "/pay",
			component: Pay
		},
		{
			name: "view",
			path: "/view/:id",
			component: ViewEvento
		}
	];
}

if (site == "Stream1x2") {
	arrRotas = [
		{
			name: "home",
			path: "/",
			component: Home3
		},
		{
			name: "administracao",
			path: "/admin",
			component: Administracao
		},
		{
			name: "sessoes",
			path: "/sessoes",
			component: SessaoView
		},
		{
			name: "sofascore",
			path: "/sofascore/:idEvento",
			component: Sofascore
		},
		{ name: "login", path: "/login", component: Login },
		{ name: "cadastro", path: "/i/:idUsuario", component: Cadastro },
		{
			name: "view",
			path: "/view/:id",
			component: ViewEvento
		}
	];
}

if (site == "Share") {
	arrRotas = [
		{
			name: "home",
			path: "/",
			component: Home2
		},
		{ name: "login", path: "/login", component: Login },
		{
			name: "usuarios",
			path: "/usuarios",
			component: ListUsuarios
		},
		{
			name: "eventos",
			path: "/eventos",
			component: Eventos
		},
		{
			name: "sessoes",
			path: "/sessoes",
			component: SessaoView
		},
		{
			name: "view",
			path: "/view/:id",
			component: ViewEvento
		},
		{
			name: "transmit",
			path: "/transmit/:id",
			component: TransmitEvento,
			props: {
				propView: ""
			}
		},
		{
			name: "meus-dados",
			path: "/meus-dados",
			component: EditUsuario,
			props: {
				propMeusDados: true,
				propView: "",
				propColunas: ["col-md-6", "offset-md-3"]
			}
		}
	];
}

if (site == "ShareApp") {
	arrRotas = [
		{
			name: "home",
			path: "/",
			component: Eventos
		},
		{ name: "login", path: "/login", component: Login },
		{
			name: "eventos",
			path: "/eventos",
			component: Eventos
		},
		{
			name: "view",
			path: "/view/:id",
			component: ViewEvento
		},
		{
			name: "transmit",
			path: "/transmit/:id",
			component: TransmitEvento,
			props: {
				propView: ""
			}
		}
	];
}

if (site == "7live") {
	arrRotas = [
		{
			name: "home",
			path: "/",
			component: HomeAoVivo
		},
		{
			name: "programacao",
			path: "/agenda",
			component: HomeProgramacao
		},
		{
			name: "sofascore",
			path: "/jrw/:idEvento",
			component: Sofascore2
		},
		{ name: "login", path: "/login", component: Login },
		{
			name: "recuperar-senha",
			path: "/recuperar-senha",
			component: LoginRecuperarSenhaEmail
		},
		{
			name: "view2",
			path: "/vid/22/11ahYuhd/:id",
			component: ViewEvento2
		},
		{
			name: "view3",
			path: "/vid/23/11akUihYuhd/:idNovo",
			component: ViewEvento2
		},
		{
			name: "meus-dados",
			path: "/conta",
			component: EditUsuario,
			props: {
				propMeusDados: true,
				propView: "",
				propColunas: ["col-md-6", "offset-md-3"]
			}
		}
	];

	if (Vue.prototype.$siteAdmin == true) {
		arrRotas = arrRotas.concat([
			{
				name: "administracao",
				path: "/admin",
				component: Administracao
			},
			{
				name: "eventos",
				path: "/eventos",
				component: Eventos
			},
			{
				name: "sessoes",
				path: "/sessoes",
				component: SessaoView
			},
			{
				name: "view",
				path: "/view/:id",
				component: ViewEvento2
			},
			
		]);

		const paramsUrl = new URLSearchParams(window.location.search);

		if (paramsUrl.has("old")) {
			arrRotas.push({
				name: "transmit",
				path: "/live/:id",
				component: TransmitEvento,
				props: {
					propView: ""
				}
			});
		}else{
			arrRotas.push({
				name: "transmit",
				path: "/live/:id",
				component: LiveTransmitEvento,
				props: {
					propView: ""
				}
			});
		}

	}
}

const router = new Router({
	mode: "history",
	routes: arrRotas
});

if (site == "Weddbets") {
	Vue.use(VueAnalytics, {
		id: "UA-175262217-1",
		router
	});
}

/*if (site == "Stream1x2") {
  Vue.use(VueAnalytics, {
    id: "G-B49DE8P44G",
    router
  });
}*/

export default router;
